import { Button, Layout } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';

const { Content } = Layout;

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '80vh',
        padding: '40px 20px',
        textAlign: 'center',
    },
    card: {
        background: '#fff',
        borderRadius: '16px',
        padding: '40px',
        maxWidth: '500px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
    },
    icon: {
        fontSize: '64px',
        marginBottom: '20px',
    },
    title: {
        fontSize: '24px',
        fontWeight: 700,
        color: '#1a1a1a',
        marginBottom: '12px',
    },
    text: {
        fontSize: '15px',
        color: '#666',
        marginBottom: '24px',
        lineHeight: '1.6',
    },
    button: {
        height: '44px',
        fontSize: '15px',
        fontWeight: 600,
        borderRadius: '8px',
    },
};

export const Battle = () => {
    return (
        <Content>
            <div style={styles.container}>
                <div style={styles.card}>
                    <div style={styles.icon}>🚫</div>
                    <h1 style={styles.title}>Multiplayer je dočasně nedostupný</h1>
                    <p style={styles.text}>
                        Omlouváme se, ale z důvodu omezených API kreditů je multiplayer dočasně vypnutý.
                        Spotřebovává příliš mnoho zdrojů a ohrožoval by fungování singleplayer her.
                        <br /><br />
                        Zkus to prosím později, nebo si zatím zahraj sám.
                    </p>
                    <Link to="/">
                        <Button type="primary" size="large" style={styles.button}>
                            Zpět na hlavní stránku
                        </Button>
                    </Link>
                </div>
            </div>
        </Content>
    );
};
